import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { requestOtp, validateOtp } from "./otp.api";
import type { OtpRequestInput, OtpValidateInput } from "./otp.schema";

export const useRequestOtpMutation = (
  options?: Omit<
    UseMutationOptions<boolean, Error, OtpRequestInput>,
    "mutationKey" | "mutationFn"
  >,
) => {
  return useMutation({
    ...options,
    mutationKey: ["requestOtp"],
    mutationFn: (input: OtpRequestInput) => requestOtp({ data: input }),
  });
};

export const useValidateOtpMutation = () => {
  return useMutation({
    mutationKey: ["validateOtp"],
    mutationFn: (input: OtpValidateInput) => validateOtp({ data: input }),
  });
};
